import { ICtrl, ICtrlList, ICtrlParam, ICtrlRadio, IParam } from 'fwork.react.test/src/components/ctrlParams/models'
import { JwtPayload } from 'jsonwebtoken'

// OBS.: NAO USAR CAMEL CASE NA NOMECLATURA DE CAMPOS NESSE MODELO

export enum CrudStatus {
  undefined,
  insert,
  update,
  delete,
}

export interface ICounter {
  id: string,
  seq: number
}

export interface IUserLogItem {
  description: string,
  value: Object,
}

export interface IUserLog {
  id: number,
  date: Date,
  description: string,
  additional_description: string,
  // logs: Object[],
  logs: IUserLogItem[]

  user_id: number,
  user?: IUser,

  user_log_group_id?: number,
  user_log_group?: IUserLogGroup,
}

export interface IUserLogGroup {
  id: number,
  name: string,

  // logs_id: number,
  logs?: IUserLog[]
}

// NAO TEM SCHEMA NO BANCO
export interface IAuthentication {
  token: string,
  user: IUser | undefined
}

// NAO TEM SCHEMA NO BANCO
export interface IAuthenticationTokenData extends JwtPayload {
  user: IUser,
  // expiration_utc_date: string,
}

export interface IUser {
  id: number,
  name: string,
  login: string,
  pwd: string,
  default?: boolean,

  //NÃO VAI PRO BANCO
  old_pwd?: string,
  authorization_ids?: number[],

  logs?: IUserLog[]
  groups?: IUser_Group[]
}

export interface ISport {
  id: number,
  name: string,
  resultMin: number,

  events?: IEvent[],
  score_types?: IScoreType[],
}

export interface ITournament {
  id: number,
  name: string,
  out_name?: string,
  
  location_id?: number,
  location?: ILocation,
  full_name?: string, // NAO EXISTE NO BANCO MAS NAO É UM VIRTUAL DO MOGOOSE. É ADICIONADO ATRAVES DO ADDFIELDDS NO DATASOURCE

  events?: IEvent[]
}

export interface IParticipant {
  id: number,
  name: string,
  out_name?: string,
  image_id?: string,
  image_id_bkp?: string,

  events?: IEvent[]
}

export interface ILocation {
  id: number,
  name: string,

  events?: IEvent[],
  tournaments?: ITournament[],
}

export interface IEventStatus {
  id: number,
  name: string,

  events?: IEvent[]
}

export interface IScoreType {
  id: number,
  name: string,
  sport_id: number,
  sport?: ISport,
  always_show?: boolean,
}

export interface IEventScoreBoardResult {
  position: number,
  value: string,
}

export interface IEventScoreBoard {
  id: number,
  score_type_id: number,
  name: string,
  result: IEventScoreBoardResult[]
}

export interface IEvent {
  id: number,
  start_date: Date,
  ts: number,
  c_at: Date,
  u_at?: Date,
  bet365_fixture_id: string,
  betsapi: number,

  status_id: number,
  status: IEventStatus, // NAO VAI PRA O BANCO
  sport_id: number,
  sport?: ISport, // NAO VAI PRA O BANCO
  location_id: number,
  location?: ILocation, // NAO VAI PRA O BANCO
  tournament: ITournament,

  participants: IParticipant[]
  bets?: IBet[] // NAO VAI PRA O BANCO
  score_board?: IEventScoreBoard[]
}

export interface IBookmakerPrice {
  bookmaker_id: number,
  status: number,
  price: number,
  // bet_id: BigInt,
  u_at: string,
}

export interface IBetStatus {
  id: number,
  name: string,

  bets?: IBet[]
}

export interface IBetSettlement {
  id: number,
  name: string,

  bets?: IBet[]
}

export interface IMarket {
  id: number,
  name: string,

  bets?: IBet[]
}

export interface IBet {
  id: number,
  type_id: number,
  subtype_id: string,
  name: string,
  price: number,
  key_tag: string,
  book_number: number,
  column: number,
  bookmaker_prices: IBookmakerPrice[],
  c_at: Date,
  u_at: Date,
  ts?: number,

  market_id: number,
  market?: IMarket,
  status_id: number,
  status?: IBetStatus,
  settlement_id: number,
  settlement?: IBetSettlement,
  settlement_date?: Date,
  event_id: number,
  event?: IEvent,

  // NAO VAO PARA O BANCO, APENAS PARA CONTROLE NO FRONT
  crudStatus?: CrudStatus,
  priorState?: IBet,
}

export interface IAuthorization {
  id: number,
  name: string,
  // auth_key?: number,
  default?: boolean,

  usersgroups?: IUserGroup_Authorization[],
}

export interface IUserGroup {
  id: number,
  name?: string,
  default?: boolean,

  users?: IUser_Group[]
  authorizations?: IUserGroup_Authorization[]
}

export interface IUserGroup_Authorization {
  uuid?: string,
  id: number,

  authorization_id: number,
  authorization?: IAuthorization,
  usergroup_id: number,
  usergroup?: IUserGroup,
  default?: boolean,
}

export interface IUser_Group {
  uuid?: string,
  id: number,

  user_id: number,
  user?: IUser,
  usergroup_id: number,
  usergroup?: IUserGroup,
  default?: boolean,
}

export interface IDbTaskScreenCtrl extends ICtrl, ICtrlParam, ICtrlList, ICtrlRadio {

}

export interface IDbTask {
  _id: any,
  id: number,
  name: string,
  script_sql: string,
  screen_ctrols: IDbTaskScreenCtrl[],
  active?: boolean,
  auth_id?: number,
  log_group_id?: number
}

// NAO TEM SCHEMA NO BANCO
export interface IDbTaskExecOptions {
  sessionUuid: string,
  task_id: number,
  db_list_names: string[],

  params?: IParam[],
  override_sql?: string,
}

export interface IDbTaskExecOptionsRmq extends IDbTaskExecOptions {
  auth_token: string,
  log_id: number,
  ping?: boolean,
}

// NAO TEM SCHEMA NO BANCO
export enum IDbTaskExecResultStatus {
  waiting,
  success,
  error,
}

// NAO TEM SCHEMA NO BANCO
export interface IDbTaskExecResult {
  sessionUuid: string,
  task_id: number,
  db_name: string,
  auth_token: string,

  status: IDbTaskExecResultStatus,
  msg?: string,
  result_set: any,
  log_id: number,
}

export interface ICompanyGroup {
  id: number,
  name: string,
  companies?: ICompany_group[]
}

export interface ICompany_group {
  uuid: string,
  id: number,
  company_id: number,
  company?: ICompany,
  group_id: number,
  group?: ICompanyGroup,
}

export interface ICompany {
  id: number,
  name: string,
  database_name: string,
  groups?: ICompany_group[]
}